module.exports = __webpack_public_path__ + "img/iphone.bfca8f08.png";